import styled from "styled-components";
import media from "styled-media-query";

import bg from '../../assets/bg-fortnite.jpg'

export const SectionSteps = styled.section`
  background-image: url(${bg});
  background-size: cover;
  background-position: center center;
  position: relative;
  z-index: 2;
  clip-path: polygon(0 0, 100% 7vw, 100% 100%, 0 calc(100% - 7vw));

  &::before {
    content: '';
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    background: rgba(0, 0, 0, 0.7);
    z-index: -1;
  }

  padding: 181px 24px 317px;
  ${media.lessThan('1366px')`
    padding: 150px 0 180px;
  `}

  ${media.lessThan('1024px')`
    padding: 140px 24px 120px;
  `}

  .container {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    ${media.between('1024px', '1366px')`
      max-width: 920px;

      & > button {
        height: 65px;
        width: 300px;
        font-size: 18px;
      }
    `}

    .title {
      color: #fff;
      font-weight: 900;
      font-size: 40px;
      line-height: 49px;
      text-align: center;
      margin-bottom: 93px;
      ${media.lessThan('1366px')`
        font-size: 28px;
        line-height: 28px;
        margin-bottom: 64px;
      `}

      ${media.lessThan('1024px')`
        font-size: 24px;
        line-height: 29px;
        margin-bottom: 64px;
      `}
    }

    .title.title-section {
      text-align: left;
    }

    .note-prizes {
      font-weight: 500;
      font-size: 14px;
      line-height: 17px;
      color: #fff;
      margin: 28.7px 0 40px;
      ${media.lessThan('1366px')`
        font-size: 10px;
        line-height: 12px;
      `}

      ${media.lessThan('1024px')`
        font-size: 12px;
        font-weight: 500;
        line-height: 15px;
        letter-spacing: 0em;
        margin: 0 0 40px;

      `}
    }

    .steps-container {
      display: grid;
      grid-template-columns: repeat(4, 1fr);
      gap: 0 25px;

      ${media.lessThan('1366px')`
        gap: 0 10px;
      `}

      ${media.lessThan('1024px')`
        grid-template-columns: 1fr;
        gap: 50px;
        margin-bottom: 33px;
      `}
    }

    .lucky-number {
      padding: 0 45px;
      margin-top: 69px;

      ${media.lessThan('1366px')`
        padding: 0 60px;
        margin-top:27px;
      `}

      ${media.lessThan('1024px')`
        padding: 0;
        margin-top:37px;
      `}
      
      form {
        display: flex;
        justify-content: space-between;
        align-items: center;


        ${media.lessThan('1024px')`
          flex-direction: column;  
          justify-content: initial;
          gap: 32px 0;
          margin-top:37px;
          padding: 0 7px;
        `}

        ${media.between('1024px', '1366px')`
          button {
            height: 56px;
            font-size: 18px;
            max-width: 280px;
          }
        `}
        .code-input {
          background-color: #fafafa;
          padding: 0 50px;
          width: 100%;
          max-width: 819px;
          height: 76px;
          border: 1px solid #E5E5E5;
          border-radius: 8px;
          color: #808080;
          font-weight: 400;
          font-size: 22px;
          font-family: 'Open Sans', sans-serif;
          margin-right: 30px;

          ${media.lessThan('1366px')`
            padding: 0 32px;
            height: 56px;
            border-radius: 6px;
            color: #808080;
            font-size: 16px;
            margin-right: 20px;
          `}

          ${media.lessThan('1024px')`
            padding: 0 18px;
            height: 48px;
            font-size: 16px;
            margin-right: 0;
          `}
        }
      }
    }
  }
`